<template>
    <div id="app" class="primary-bg-white">
        <router-view />
    </div>
</template>

<script>
// import temp from '@pages/commonTemp.vue'
export default {
    name: "App",
    data() {
        return {
            queryData: {},
        };
    },
    provide() {
        return {
            urlData: () => {
                return { ...this.queryData };
            },
        };
    },
    created() {
        // this.$dispatch('basic','LISTEN_CHILD',{method: 'openTab', data:{a: 1}})
        this.judgeOpenType();
        // this.$router.push(`/pages`);
    },
    methods: {
        async judgeOpenType() {
            this.queryData = this.$utils.getUrlParams();
            const isbrokerApp = Number(await this.$client.isbrokerApp()) !== 800;
            //是否是券商
            if (isbrokerApp) {
                if (this.queryData.treeid == "14374" || this.queryData.treeid == "14341") {
                    this.queryData.type = "notice"; //公告
                } else {
                    this.queryData.type = "broker"
                }
            } else {
                if (this.queryData.treeid == "14375") {
                    this.queryData.type = "news"; //新闻
                    if (this.queryData.tagname) {
                        this.queryData.type = "tags";
                    }
                } else if (this.queryData.treeid == "14340") {
                    this.queryData.type = "industry"; //行业资讯
                } else if (this.queryData.treeid == "14364") {
                    this.queryData.type = "report"; //研报
                } else if (this.queryData.treeid == "14374" || this.queryData.treeid == "14341") {
                    this.queryData.type = "notice"; //公告
                } else if (this.queryData.treeid == "14362") {
                    this.queryData.type = "view_point"; //高手观点
                } else if (this.queryData.treeid == "14343") {
                    this.queryData.type = "industry_report"; //行业研报
                } else if (this.queryData.seq) {
                    this.queryData.type = "single_article";
                } else {
                    //默认使用资讯
                    this.queryData.type = "news"; //新闻
                }
            }
            this.$router.push(`/pages`);
        },
    },
};
</script>

<style lang="less">
#app {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}
.curp {
    cursor: pointer;
}
</style>
